var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDifficulty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1994 12.1063C10.1673 12.1544 10.1343 12.202 10.1006 12.2489C9.43918 13.2301 8.49384 13.8843 7.39877 14.1859C7.71855 14.0069 7.99634 13.7545 8.21351 13.4324C8.23053 13.4087 8.24717 13.3847 8.26342 13.3604C8.47628 13.0418 8.61416 12.6809 8.66887 12.3048C8.70179 12.1239 8.71906 11.9366 8.71906 11.7449C8.71906 10.9619 8.43086 10.2531 7.96515 9.74071C7.8225 10.0646 7.62256 10.3575 7.37817 10.6066C7.34187 9.33817 6.72128 8.21606 5.77608 7.5C5.65372 8.45671 5.19695 9.30888 4.52671 9.93557C4.19119 10.2047 3.92777 10.5548 3.76225 10.9544C3.56817 11.423 3.51739 11.9386 3.61633 12.436C3.71527 12.9334 3.95949 13.3903 4.31811 13.7489C4.54794 13.9788 4.81815 14.1616 5.11352 14.2894C5.07099 14.282 5.02852 14.2741 4.98612 14.2657C4.001 14.0697 3.09611 13.5861 2.38588 12.8758C1.67565 12.1656 1.19197 11.2607 0.99602 10.2756C0.800068 9.29048 0.900638 8.26938 1.28501 7.34142C1.61283 6.55 2.13451 5.85665 2.799 5.32358C4.1264 4.08243 5.031 2.39474 5.27334 0.5C7.14527 1.91814 8.37433 4.14043 8.44622 6.65257C8.93024 6.15912 9.32621 5.57901 9.60872 4.93766C10.5311 5.95238 11.1018 7.3561 11.1018 8.90693C11.1018 9.28657 11.0676 9.65739 11.0024 10.0159C10.8941 10.7607 10.621 11.4754 10.1994 12.1063Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDifficulty);
export default __webpack_public_path__ + "static/media/icon_difficulty.bf991c15919d631af6cb784b2139c7ea.svg";
export { ForwardRef as ReactComponent };